import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createNewNewsCat,
  getANewsCat,
  resetState,
  updateANewsCat,
} from "../features/bcategory/bcategorySlice";
let schema = yup.object().shape({
  category_name: yup.string().required("Category Name is Required"),
});
const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.bCategory);
  const {
    isSuccess,
    isError,
    isLoading,
    createNewsCategory,
    categoryname,
    updatedNewsCategory,
  } = newNewsCategory;
  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getANewsCat(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsCatId]);
  useEffect(() => {
    if (isSuccess && createNewsCategory) {
      toast.success("News Category Added Successfullly!");
      navigate("/admin/News-category-list");
    }
    if (isSuccess && updatedNewsCategory) {
      toast.success("News Category Updated Successfullly!");
      navigate("/admin/News-category-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category_name: categoryname || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { id: getNewsCatId, NewsCatData: values };
      if (getNewsCatId !== undefined) {
        dispatch(updateANewsCat(data));
        dispatch(resetState());
      } else {
        dispatch(createNewNewsCat(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });
  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} News Category
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="category_name"
            onChng={formik.handleChange("category_name")}
            onBlr={formik.handleBlur("category_name")}
            val={formik.values.category_name}
            label="Enter News Category"
            id="category_name"
          />
          <div className="error">
            {formik.touched.category_name && formik.errors.title}
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading} 
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            { isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} News Category
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
